import * as React from "react";
import styled from "styled-components";
import * as h from "../../../../../../ui/_themes/helpers";

interface IProps {
  content: string;
}

export const ExternalPaneDescription = ({ content }: IProps) => {
  const Wrapper = styled.div`
    color: ${h.getColor("settingsWindowSubTitle", "settingsWindow.subtitle")};
    margin-bottom: 1.2em;
    font-size: 0.88em;
    font-weight: 700;
    letter-spacing: 0.03em;
    padding-top: 0.6em;
  `;
  return <Wrapper dangerouslySetInnerHTML={{ __html: content }} />;
};
